export default __webpack_public_path__ + "static/media/Lab_Coat.c60ab39a.svg";